import { IStore } from 'store/interface';

export const getModalState = ({ modals }: IStore, modalName: string) =>
  modals.get(modalName) || false;
